import { useCallback } from 'react';
import { isNil, type LoggingChannel } from 'shared/src/utils';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import { useGoodsDetail } from '../queries/useGoodsDetail';
import { useGoodsBasic } from '../queries/useGoodsBasic';

export const useLogGoodsAnalyticsEvent = () => {
  const { data: goodsDetail } = useGoodsDetail();
  const { data: goodsBasic } = useGoodsBasic();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback<
    (params: {
      name: string;
      channel?: Array<LoggingChannel>;
      analytics?: Record<string, unknown>;
    }) => boolean
  >(
    params => {
      if (isNil(goodsDetail)) return false;
      if (isNil(goodsBasic)) return false;

      logAnalyticsEvent({
        name: params.name,
        channel: params.channel ?? [
          'firebase',
          'facebook',
          'amplitude',
          'ablylog',
        ],
        analytics: {
          ...params.analytics,
          EVENT_TYPE: params.name,
        },
      });

      return true;
    },
    [goodsDetail, goodsBasic, logAnalyticsEvent],
  );
};
